import React from 'react';

export const numberInTextFormat = number => {
  if (!number) return '---';
  if (isNaN(number)) return 'NA';
  if (number >= 10000 && number < 100000)
    return `${parseFloat(number / 1000)?.toFixed(2)}K`;
  if (number >= 100000 && number < 10000000)
    return `${parseFloat(number / 100000)?.toFixed(2)}L`;
  if (number >= 10000000)
    return `${parseFloat(number / 10000000)?.toFixed(2)}Cr`;
  return number;
};
